/**
 * 字段说明
 *      is_button:          Boolean 是否显示按钮
 *      btn_text:           Boolean 按钮文字
 *      bg_image:           Boolean 是否显示背景图片
 *      bg_color:           String  显示的背景颜色
 * 		block: 		        Array	块
 *      data:               Array   方程式的jsonStr.su
 * 		title: 		        String	标题
 * 		content: 	        String	内容
 * 		photo: 		        String  主要图片
 * 		name: 		        String  标题
 * 		logo: 		        String  logo图片
 * 		image: 		        String  背景图片
 * 		picture: 	        Array	轮播图片
 * 		alt: 		        String	图片说明
 * 		url: 		        String	按钮跳转
 * 		audio_url:      	String	音频链接
 * 		video_url:      	String	视频链接
 * 		threedobject_url:	String  3D模型链接
 * 		object_id:      	String	对象id
 * 		user_id: 	        String	所属用户id
 * 		tuwen_content: 	    String	图文内容
 * 		_tuwen_data: 	    Object	图文数据
 * 		_object_data: 	    Object	对象数据
 * 		_phamula_data: 	    Object	方程式数据
 * */


export default {
	props: {
        index: {
            type: Number,
            default: 0
        },
		typeData: {
			type: Object,
			default: () => {
				return {
                    // id: String
					// data: Object
					// type: String
                    // many: Boolean
					// object_id_list: Array
				};
			}
		},
        themeColor: {
            type: String,
            default: '#41466E'
        }
	},
    watch: {
        typeData: {
            handler(newValue) {
                // console.log(this.index, JSON.parse(JSON.stringify(newValue)), JSON.parse(JSON.stringify(this.showData)));
            },
            deep: true
        }
    },
	created() {
		// console.log(this.index, JSON.parse(JSON.stringify(this.typeData)), JSON.parse(JSON.stringify(this.showData)));
	},
	methods: {
		jumpAction(item) {
            // console.log('跳转', JSON.parse(JSON.stringify(this.typeData)), JSON.parse(JSON.stringify(item)));
			// return;
			let url = item.url || '';
            // 导航栏点击的
            if (['typeHeader', 'typeFooter'].indexOf(this.typeData.type) > -1) {
				//console.log('in JumpAction!!',item,item.id,item.object_id, item._object_id);
                if (item.object_id) {
                    const index = this.$parent.xitoList.findIndex(v => v.object_id_list.indexOf(item.object_id) > -1);
                    // 跳到某个块区域
                    if (index > -1) {
                        const id = '#' + this.$parent.xitoList[index].id;
                        const scrollTop = ($(id) && $(id).offset && $(id).offset().top) || 0;
                        $('body,html').animate({ scrollTop }, 300);
                        return;
                    }
                }
            }
			// 其它组件点击的
			else {
				// 当前链接替换参数
				if (item.btn_text[0] === '?') {
					window.open(window.location.origin + item.btn_text, '_blank');
					return;
				}
			}
            if (url) {
            	window.open(url, '_blank');
            }
		}
	},
	computed: {
		padding() {
			return !this.showData.width_full;
		},
		showData() {
			return this.typeData.data || (this.typeData.many ? [] : {});
		},
        // bgImage() {
        //     return (this.showData.bg_image && this.showData.image) ? this.showData.image : '';
        // },
        userPhoto() {
        	return require('../../../assets/image/user.png');
        },
		buttonStyle() {
			return [
				`color: #FFFFFF;background-color: ${this.themeColor};`,
				`color: ${this.themeColor};background-color: #FFFFFF;`
			];
		},
		contentColor() {
			if (this.whitebackdrop) {
                return 'color: #797979';
			}
            return 'color: #FFFFFF';
		},
		whitebackdrop() {
            // 白色背景
			return this.typeData.many ? true : (this.showData.image ? false : true);
		}
	}
}